<ng-container *ngIf="config.isVisible">
    <div class="row">
        <div class="col-lg-11">
            <ng-container *ngIf="config.label">
                <label [for]="config.id"
                    ><strong>{{ config.label }}</strong></label
                ></ng-container
            ><br />
            <ng-container
                *ngIf="
                    editMode &&
                    userService.userHasChampUpdatePermissionAccess(config.name, typeName)
                "
            >
                <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                    <input
                        [type]="config.type.toLowerCase()"
                        [id]="config.label"
                        [placeholder]="config.label"
                        [name]="config.name"
                        [(ngModel)]="value"
                        [value]="config.value ? config.value : ''"
                        [disabled]="config.disabled || !config.isModifiable"
                        matInput
                    />
                </mat-form-field>
            </ng-container>
            <ng-container
                *ngIf="
                    !editMode ||
                    (!userService.userHasChampViewPermissionAccess(config.name, config.typeName) &&
                        editMode)
                "
            >
                <div>
                    <span
                        *ngIf="isColorHexa"
                        style="display: inline-block; width: 12px; height: 12px; border-radius: 50%"
                        [ngStyle]="{ 'background-color': value }"
                    ></span>

                    <ng-container *ngIf="typeOf(value) === 'object'; else elseTemplateNotOject">
                        <div *ngFor="let local of languages">
                            <ng-container *ngIf="isLocal(local.key) && local.key !== 'all'">
                                <div class="d-flex">
                                    <div class="mx-1">
                                        <label *ngIf="local">{{ multilangueMap[local.key] }}</label>
                                        <label *ngIf="!local">-</label>
                                    </div>
                                </div>
                                <br />
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-template #elseTemplateNotOject>
                        {{ value }}
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
